var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.82502 5.31733C8.4345 5.70786 8.4345 6.34102 8.82502 6.73155L11.1967 9.10319C11.5872 9.49371 11.5872 10.1269 11.1967 10.5174L10.4685 11.2456C10.078 11.6361 9.4448 11.6361 9.05428 11.2456L6.68264 8.87393C6.29212 8.4834 5.65895 8.48341 5.26843 8.87393L2.91635 11.226C2.52583 11.6165 1.89266 11.6165 1.50214 11.226L0.773971 10.4978C0.383447 10.1073 0.383448 9.47415 0.773971 9.08362L3.12605 6.73155C3.51657 6.34102 3.51657 5.70786 3.12605 5.31733L0.754407 2.94569C0.363883 2.55517 0.363883 1.92201 0.754407 1.53148L1.48258 0.803313C1.8731 0.412789 2.50626 0.412789 2.89679 0.803313L5.26843 3.17495C5.65895 3.56548 6.29212 3.56548 6.68264 3.17495L9.08363 0.773965C9.47415 0.383441 10.1073 0.383441 10.4978 0.773965L11.226 1.50213C11.6165 1.89266 11.6165 2.52582 11.226 2.91635L8.82502 5.31733Z",
    fill: "#F33325"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.2eec487fbcf28cd2310b53a588938e32.svg";
export { ForwardRef as ReactComponent };